import React, { useEffect, useState, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeTags } from 'Core/hooks';
import { InputSearch, Loading, Select } from 'Components';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { OrderData } from 'Core/data/Helpers'
import { Icon } from '@mui/material';
import { TagsGroup } from 'Components/Tag';

import { getEventColor } from 'Components/Map/utils';
import { TypeObjectMap } from 'Components/Map/providers/enums'
import styles from 'Assets/sass/core/vars.scss';
import InfiniteScroll from "react-infinite-scroll-component";

import GeofenceAssign from '../geofenceAssign';

import {
    searchUnitsGeofence,
    mapGeofencesOpenCloseAssignModal,
    centerOnUnit,
    getTagsVehicleList
} from 'Redux/actions';

import './style.scss';

const LIMIT_PAGE = 10;

const GeofenceSettingsViewUnits = (props) => {

    const { mapRef } = props;
    const { messages } = useIntl();

    /*********************************************************
     * Const and useState
    *********************************************************/
    const dispatch = useDispatch()
    const [filter, setFilter] = useState('')
    const [data, setData] = useState([])
    const [page, setPage] = useState(1);
    const [selectedRow, setSelectedRow] = useState();
    const [group, setGroup] = useState();

    /*********************************************************
     * Use Selector
    *********************************************************/
    const { unitGeofence, loadingResponse } = useSelector((state) => state.realtimeMapGeofenceSettingsViewUnitsModuleRedux);
    //const { unitGroups, loadingUnitGroups } =  useSelector((state) => state.realtimeMapRedux);
    const { tagsVehicleList, loadTagsVehicleList } = useSelector(state => state.realtimeMapUtilitiesVehiclesListRedux);

    const tags  = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags', 'color', 'parentId'] });
    const haveUntagged = tags?.find(t => t?.id == -1) ? true : false;

    const {
        open: openAssign
    } = useSelector((state) => state.realtimeMapGeofenceAssignRedux);

    /*********************************************************
     * load the UnitsGeofence
    *********************************************************/
    useEffect(() => {
        dispatch(searchUnitsGeofence())
        dispatch(getTagsVehicleList())
    }, []);

    /*********************************************************
     * Set the landmarks by rows per page in start data
    *********************************************************/
     useEffect(() => {
        if(group) setFilter('');
        if (unitGeofence && unitGeofence.length > 0) {
            restartView();
        } else {
            setData([]);
        }
    }, [group, unitGeofence])

    /*********************************************************
     * Restart the elements into the view
    *********************************************************/
    const restartView = () => {
        setSelectedRow(null);
        setPage(1); //start page count
        getItemsGeofence(1);
    }

    /*********************************************************
     * Draw the landmarks into the map
    *********************************************************/
     const getItemsGeofence = (newPage = 0) => {
        if (unitGeofence && unitGeofence.length > 0) {
            let filteredGeofences = [];
            filteredGeofences = getItemsByGroup();
            let newGeofences = OrderData(filteredGeofences, 'name');
            newGeofences = formatSetData(newGeofences.slice(0, (newPage > 0 ? newPage : page) * LIMIT_PAGE))
            setData(newGeofences)
        } else {
            setData([])
        }
    }

    const getItemsByGroup = () => {
        if (group && unitGeofence && unitGeofence.length > 0) {
            let filterByGroup = [];
            const idsGroups = group.map((item) => item.id);
            unitGeofence.forEach((unit) => {
                if(unit.unitTags && unit.unitTags.length > 0){
                    const findElement = unit.unitTags.find((valueGroup) => idsGroups.includes(valueGroup.id));
                    if (findElement) filterByGroup.push(unit);
                } else if (idsGroups.includes(0) && !unit.unitTags?.length) {
                    filterByGroup.push(unit);
                }
            })
            return filterByGroup;
        }
        return unitGeofence;
    }


    /*********************************************************
     * Use effect to load landmarks groups
    *********************************************************/
    const formatSetData = (dataGeofence) => {
        //if (data.length <= 0 && unitGeofence && unitGeofence.length > 0) {
        if (dataGeofence && dataGeofence.length > 0) {
            const dataUnits = []
            dataGeofence.forEach((item) => {
                const markerObject = mapRef.current.getObject(TypeObjectMap.Marker, item.unitId)
                const haveMarker = markerObject ? true : false;
                const newUnitGeofence = {
                    ...item,
                    showOnMap: haveMarker,
                    eventName: haveMarker ? markerObject.eventName : '',
                    color: haveMarker ? getEventColor(markerObject.eventName) : styles.color_evnt_other
                }
                dataUnits.push(newUnitGeofence)
            })
            return dataUnits;
        }
        return []
    }

    /*********************************************************
     * Select the card into the table
    *********************************************************/
    const onSelectCard = (row) => {
        if (row?.unitId == selectedRow?.unitId) {
            setSelectedRow(null);
        } else {
            setSelectedRow(row);
            //fin Unit on map
            if(row.showOnMap){
                dispatch(centerOnUnit(row.unitId, false));
                if (props?.mapRef && !props.mapRef.current?.getOpenInfoWindow()) {
                    props?.mapRef?.current?.showInfoWindow(row.unitId);
                }
            }
        }
    }

    /*********************************************************
     * set the new page from event infinite scroll
    *********************************************************/
     const setNoPage = (page) => {
        setPage(page);
        getItemsGeofence(page);
    }

    /*********************************************************
     * Filter landmark groups by key press
    *********************************************************/
    const onSearch = useCallback((value) => {
        setFilter(value);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        if(!value){
            restartView();
            return;
        }

        if(group){
            setGroup(null)
        }

        window.typingTime = setTimeout(() => {
            let newFilter = unitGeofence.filter((item) => item.name.toLocaleLowerCase().includes(value.toLocaleLowerCase()));
            newFilter = OrderData(newFilter.slice(0, LIMIT_PAGE * 2), 'name');
            newFilter = formatSetData(newFilter)
            setData(newFilter);
            window.typingTime = null;
        }, 1000);
    });

    const getTags = () => {
        if (haveUntagged){
            let tagItems = [];
            tagItems = [...tagItems, ...(tagsVehicleList || []) ];
            tagItems = tagItems ? OrderData(tagItems, "label") : [];
            tagItems.unshift({
                id: 0, 
                label: messages['untagged'], 
                color: styles.color_untagged,
                visible: true,
                open: false,
                items: []
            })

            return tagItems;
        }

        return tagsVehicleList ? OrderData(tagsVehicleList, "label") : [];
    }

    return (
        <div>
            <Grid container spacing={0}>
                <Grid item sm={12}>
                    <InputSearch
                        searchText={filter}
                        onSearch={(param) => onSearch(param)}
                    />
                </Grid>
                <Grid item sm={12} style={{ marginBottom: 8 }}>
                    <Select
                        label={''}
                        value={group}
                        placeholder={messages['maputilities_visible_filterByTags']}
                        onChange={(event) => setGroup(event)}
                        id="id"
                        className="react-select-landmark"
                        options={getTags()}
                        textField={'label'}
                        valueField={'id'}
                        required
                        disabled={loadTagsVehicleList}
                        multiple
                    />
                </Grid>
            </Grid>

            <InfiniteScroll
                dataLength={data.length}
                height={520}
                next={() => {
                    if(!filter){ //when the user not filter de data
                        setNoPage(page + 1);
                    }
                }}
                hasMore={(unitGeofence.length > data.length)}
                loader={<span />}
                endMessage={""}
            >
                
                    {
                        loadingResponse ?
                        <div style={{ padding: 20 }}><Loading full /></div> :
                            <Grid
                                container
                                direction="column"
                                justifyContent="flex-start"
                                alignItems="flex-start"
                            >
                                {
                                    data.map((row, index) => {
                                        let selected = selectedRow ? selectedRow.unitId === row.unitId : false;
                                        return (
                                            <Grid
                                                key={index}
                                                item
                                                xs
                                                style={{
                                                    width: '100%',
                                                    margin: 0
                                                }}
                                            >
                                                <div style={{ padding: '10px 15px 10px 2px' }}>
                                                    <div className={selected ? "lSettingsView-card lSettingsView-container-selected" : "lSettingsView-card lSettingsView-container"}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justifyContent="flex-start"
                                                            alignItems="center"
                                                            onClick={() => onSelectCard(row)}
                                                        >
                                                            <Grid item>
                                                                <Icon style={{ paddingRight: 4, width: 24, height: 24, color: row?.color }}>
                                                                    navigation
                                                                </Icon>
                                                            </Grid>

                                                            <Grid
                                                                item
                                                                xs
                                                                zeroMinWidth
                                                                style={{
                                                                    paddingRight: 24
                                                                }}
                                                                onClick={() => onSelectCard(row)}
                                                            >
                                                                <Typography
                                                                    noWrap
                                                                    variant="subtitle1"
                                                                    className="geoSettings-title"
                                                                    style={{ color: !row?.eventName ? '#D7D7D6' : '' }}
                                                                >
                                                                    {row?.name}
                                                                </Typography >
                                                            </Grid>

                                                            <Grid
                                                                container
                                                                wrap="nowrap"
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                alignItems="center"
                                                                /* onClick={() => onSelectCard(row)} */
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <Grid item xs={4}>
                                                                    <Typography noWrap variant="subtitle2" color={row?.unitId == selectedRow?.unitId ? 'inherit' : 'textSecondary'}>
                                                                        {`${messages['mapGeofenceUnitGeofence_group']}:`}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={8}>
                                                                    <TagsGroup
                                                                        options={(row.unitTags ? row.unitTags : [])}
                                                                        nameField="label"
                                                                        colorField="color"
                                                                    />
                                                                </Grid>
                                                            </Grid>

                                                            {
                                                                row?.eventName
                                                                &&
                                                                <Grid
                                                                    container
                                                                    wrap="nowrap"
                                                                    direction="row"
                                                                    justifyContent="flex-start"
                                                                    alignItems="center"
                                                                    onClick={() => onSelectCard(row)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <Grid item xs={4}>
                                                                        <Typography noWrap variant="subtitle2" color={row?.unitId == selectedRow?.unitId ? 'inherit' : 'textSecondary'}>
                                                                            {`${messages['mapGeofenceUnitGeofence_event']}:`}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={8}>
                                                                        <Typography className="lSetting-detail" noWrap variant="subtitle2" color={row?.unitId == selectedRow?.unitId ? 'inherit' : 'textSecondary'}>
                                                                            {row.eventName}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            }

                                                            <Grid
                                                                container
                                                                wrap="nowrap"
                                                                direction="row"
                                                                justifyContent="flex-start"
                                                                alignItems="center"
                                                            >
                                                                <Grid item>
                                                                    <Typography noWrap variant="subtitle2">
                                                                        {messages['mapGeofenceUnitGeofence_geofences']}:
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Typography
                                                                        noWrap
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                            color: '#04a9f4',
                                                                            marginLeft: 5
                                                                        }}
                                                                        onClick={() => dispatch(mapGeofencesOpenCloseAssignModal(true, row?.unitId, "unit"))}
                                                                    >
                                                                        {`${row.countGeofence || 0}/${row?.geofencesLimit || 0}`}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                    }
            </InfiniteScroll>

            {openAssign && <GeofenceAssign callback={() => dispatch(searchUnitsGeofence())} />}
        </div>
    )
}

export default GeofenceSettingsViewUnits;